import { API, SendRequest, axios } from "@/imports-files/common/common";

export class AddScorecardService extends SendRequest
{
    async addScorecard(params, applicant_id)
    {
        try 
        {
            const result = await axios.post(API.client.applicant.SAVE_SCORECARD.replace('$applicant_id', applicant_id),
            params,
            this.setHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
            return result;
        } 
        catch (error) 
        {
          return error;
        }
    }

}